<div class="_relative _w-full">
    <form [formGroup]="datesFormGroup">
        <div class="_flex _input-rounded _bg-transparent"
            [ngClass]="{ 
                '_border-transparent' : !border,
                '_input-rounded' : inputStyle === 'rounded',
                '_input-squared' : inputStyle === 'squared'
            }">
            <fieldset class="_flex _flex-grow _h-full _items-center _pr-4 _relative">
                <div class="_h-form-field-fat _bg-transparent _border-primary-1 _center-y-absolute _-left-4 _outline-inset _shadow" 
                    [ngClass]="{ 
                        '_hidden' : activeCalendar !== 'checkin',
                        '_input-rounded' : inputStyle === 'rounded',
                        '_input-squared' : inputStyle === 'squared'
                    }"
                    [ngStyle]="{ 'width' : 'calc(100% + 20px)' }">
                </div>
                <label [for]="id + '-checkinDate'" class="_cursor-pointer" (click)="openCheckinCalendar()">
                    <i class="fa-light fa-calendar-days _mr-2"></i>
                </label>
                <input 
                    [id]="id + '-checkin-date'"
                    formControlName="checkin"
                    readonly
                    placeholder="Check in"
                    autocomplete="off"
                    class="_cursor-pointer _w-full _h-full _overflow-ellipsis"
                    (click)="openCheckinCalendar()">
                    <i [ngClass]="{ 
                            '_text-primary-1-tint-20 _pointer-events-none _cursor-default' : !selectedCheckin, 
                            '_cursor-pointer': selectedCheckin
                        }" 
                        class="fa-light fa-xmark _z-10" 
                        (click)="updateCheckinDate(null)">
                    </i>
            </fieldset>

            <div class="_h-4/5 _w-nudge-1" [ngClass]="activeCalendar ? '_bg-white' : '_bg-primary-1-tint-10'" ></div>

            <fieldset class="_flex _flex-grow _h-full _items-center _pl-4 _relative">
                <div class="_h-form-field-fat _bg-transparent _border-primary-1 _center-y-absolute _-right-4 _outline-inset _shadow" 
                    [ngClass]="{ 
                        '_hidden' : activeCalendar !== 'checkout',
                        '_input-rounded' : inputStyle === 'rounded',
                        '_input-squared' : inputStyle === 'squared'
                    }"
                    [ngStyle]="{ 'width' : 'calc(100% + 20px)' }">
                </div>
                <label [for]="id + '-checkoutDate'" class="_cursor-pointer" (click)="openCheckoutCalendar()">
                    <i class="fa-light fa-calendar-days _mr-2"></i>
                </label>
                <input 
                    [id]="id + '-checkout-date'"
                    formControlName="checkout"
                    readonly
                    placeholder="Check out"
                    autocomplete="off"
                    class="_cursor-pointer _w-full _h-full _overflow-ellipsis"
                    (click)="openCheckoutCalendar()">
                    <i [ngClass]="{ 
                            '_text-primary-1-tint-20 _pointer-events-none _cursor-default' : !selectedCheckout, 
                            '_cursor-pointer' : selectedCheckout
                        }" 
                        class="fa-light fa-xmark _z-10" 
                        (click)="updateCheckoutDate(null)"></i>
            </fieldset>
        </div>
    </form>

    <div [ngClass]="{
            '_relative' : inline,
            '_absolute _z-50' : !inline,
            '_w-full' : !calendarSmall,
            '_w-1/2' : calendarSmall,
            '_ml-50%' : calendarSmall && activeCalendar === 'checkout'
        }">
        <div class="_border _border-primary-1 _mt-4 _rounded-lg _overflow-hidden"
            [ngClass]="{ 
                '_hidden' : activeCalendar !== 'checkin',
                '_shadow' : !inline
            }">
            <mat-card>
                <mat-calendar
                    #checkinCalendar
                    [className]="'mat-calendar checkin-calendar'" 
                    [selected]="selectedDateRange"
                    [comparisonStart]="selectedDateRange.start"
                    [comparisonStart]="selectedDateRange.end"
                    [startAt]="selectedCheckin"
                    [minDate]="minCheckinDate"
                    [maxDate]="maxCheckinDate"
                    [dateClass]="dateClass()"
                    (selectedChange)="updateCheckinDate($event)"
                    (monthSelected)="monthSelected($event, 'checkin')">
                </mat-calendar>
            </mat-card>
        </div>

        <div class="_border _border-primary-1 _mt-4 _rounded-lg _overflow-hidden"
            [ngClass]="{ 
                '_hidden' : activeCalendar !== 'checkout',
                '_shadow' : !inline
            }">
            <mat-card>
                <mat-calendar 
                    #checkoutCalendar
                    [className]="'mat-calendar checkout-calendar'"
                    [selected]="selectedDateRange"
                    [comparisonStart]="selectedDateRange.start"
                    [comparisonStart]="selectedDateRange.end"
                    [startAt]="selectedCheckout"
                    [minDate]="minCheckoutDate"
                    [dateClass]="dateClass()"
                    (selectedChange)="updateCheckoutDate($event)"
                    (monthSelected)="monthSelected($event, 'checkout')">
                </mat-calendar>
            </mat-card>
        </div>
    </div>

    <div class="_flex _items-center _justify-center _text-error-red _text-sm _text-center _mt-2" *ngIf="datesFormGroup.errors">
        <i class="fa-light fa-circle-exclamation _text-error-red _mr-1"></i>
        <span *ngIf="datesFormGroup.hasError('overlapsUnavailableDays')">
            Some of your travel dates are unavailable
        </span>
        <span *ngIf="datesFormGroup.hasError('minimumStayFailed')">
            Minimum of {{ minimumNights }} nights
        </span>
    </div>
</div>
